import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import { UserContext } from "../../../common/UserContext";
import axios from "../../../common/axios";
// import {useRovingIndex} from "../../../hooks/useRovingIndex";

const TestResultBarGraph = ({ testResult, handleOpenDialog }) => {
    const {
        userId,
        testAssignmentId,
        testQuestionResults,
        assignedDate,
        startDate,
        completeDate,
        expiredDate,
    } = testResult;
    const { user } = useContext(UserContext);

    const iterations = testResult.total - testQuestionResults.length,
        widthPercent = 100.0 / testResult.total,
        arrayOfResults = [...Array(Math.max(0, iterations)).keys()];
        // { getRovingProps, setActiveIndex } = useRovingIndex({
        // itemCount: testResult.total
    // });

    const fetchTestQuestionResult = (params) => {
        axios
            .get('/web/ui/test/teacher/testResult/questionResult', { params })
            .then((response) => {
                const {question, questionResult} = response.data;

                if(question && questionResult) {
                    handleOpenDialog(question, questionResult);
                }
            })
            .catch((error) => {
                console.error('Error loading single student result: ', error);
            });
    };

    return (
        <div className="ch-test-result-bar-graph">
            <ul
                className="ch-result-bar"
                role="list"
                aria-label={`Test results for ${testResult.total} questions`}
                tabIndex={-1}
            >
                {testQuestionResults.map((question,index) => (
                    <li
                        key={question.questionId}
                        style={{ minWidth: '16px', width: widthPercent + '%' }}
                        role="listitem"
                    >
                        <button
                            tabIndex={-1}
                            style={{width:'100%', border:'none'}}
                            className="ch-result-blk"
                            data-userid={userId}
                            data-test-assignment-id={testAssignmentId}
                            data-questionid={question.questionId}
                            aria-haspopup="dialog"
                            onClick={() => {
                                fetchTestQuestionResult({ userId, testAssignmentId, questionId: question.questionId })}}
                            title={`Question ${question.questionSeq + 1}`}
                        >
                            <div className={'ch-result' + ((question.hasUserResponse && question.result) ? ' ch-correct-bg' : (question.hasUserResponse && !question.result) ? ' ch-incorrect-bg' : '')}><span className={'ch-sr-only'}>{`${question.hasUserResponse? question.result ? 'correct answer' : 'incorrect answer':'unanswered'}, view question ${question.questionSeq + 1}`}</span></div>
                        </button>
                    </li>
                ))}

                {arrayOfResults.map((_, index) => (
                    <li
                        key={`placeholder-${index}`}
                        style={{ minWidth: '16px', width: widthPercent + '%' }}
                        role="listitem"
                    >
                        <div
                            className="ch-result-blk btn"
                            data-userid={userId}
                            data-test-assignment-id={testAssignmentId}
                            role="presentation"
                            aria-hidden="true"
                        >
                            <div className="ch-result">
                                <span className="sr-only">Unanswered question</span>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <div aria-label="Test dates">
                {assignedDate && <span>Assigned {user.dateFormat.format(assignedDate)}</span>}
                {startDate && <span>, Started: {user.dateFormat.format(startDate)}</span>}
                {completeDate && <span>, Completed: {user.dateFormat.format(completeDate)}</span>}
                {expiredDate && <span>, Expired {user.dateFormat.format(expiredDate)}</span>}
            </div>
        </div>
    );
};

export default TestResultBarGraph;
